export enum PropertiesActionTypes {
  GET_PROPERTIES = "@@PROPERTIES/GET_PROPERTIES",
  GET_PROPERTIES_SUCCESS = "@@PROPERTIES/GET_PROPERTIES_SUCCESS",
  GET_PROPERTIES_FAILURE = "@@PROPERTIES/GET_PROPERTIES_FAILURE",

  GET_PROPERTIES_CSV = "@@PROPERTIES/GET_PROPERTIES_CSV",
  GET_PROPERTIES_CSV_SUCCESS = "@@PROPERTIES/GET_PROPERTIES_CSV_SUCCESS",
  GET_PROPERTIES_CSV_FAILURE = "@@PROPERTIES/GET_PROPERTIES_CSV_FAILURE",

  GET_PROPERTY = "@@PROPERTIES/GET_PROPERTY",
  GET_PROPERTY_SUCCESS = "@@PROPERTIES/GET_PROPERTY_SUCCESS",
  GET_PROPERTY_FAILURE = "@@PROPERTIES/GET_PROPERTY_FAILURE",

  CHECK_IF_PROPERTY_COULD_BE_ASSIGNED_TO_LEAD = "@@PROPERTIES/CHECK_IF_PROPERTY_COULD_BE_ASSIGNED_TO_LEAD",
  CHECK_IF_PROPERTY_COULD_BE_ASSIGNED_TO_LEAD_SUCCESS = "@@PROPERTIES/CHECK_IF_PROPERTY_COULD_BE_ASSIGNED_TO_LEAD_SUCCESS",
  CHECK_IF_PROPERTY_COULD_BE_ASSIGNED_TO_LEAD_FAILURE = "@@PROPERTIES/CHECK_IF_PROPERTY_COULD_BE_ASSIGNED_TO_LEAD_FAILURE",

  ASSIGN_TO_LEAD = "@@PROPERTIES/ASSIGN_TO_LEAD",
  ASSIGN_TO_LEAD_SUCCESS = "@@PROPERTIES/ASSIGN_TO_LEAD_SUCCESS",
  ASSIGN_TO_LEAD_FAILURE = "@@PROPERTIES/ASSIGN_TO_LEAD_FAILURE",

  SELECT_PROPERTY = "@@PROPERTIES/SELECT_PROPERTY",
  UNSELECT_PROPERTY = "@@PROPERTIES/UNSELECT_PROPERTY",
  SELECT_ALL_PROPERTIES = "@@PROPERTIES/SELECT_ALL_PROPERTIES",
  UNSELECT_ALL_PROPERTIES = "@@PROPERTIES/UNSELECT_ALL_PROPERTIES",

  SET_FILTER = "@@PROPERTIES/SET_FILTER",

  CLEAR_ERRORS = "@@PROPERTIES/CLEAR_ERRORS",
}
